module.exports = __webpack_public_path__ + "img/25_25.0d3cd00e.png";